module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAABGdBTUEAALGPC/xhBQAAAEhQTFRFAAAA/7/f/8PD/8bG/7/C/8DC/8DB/8DC/8DB/8DC/7/B/7/B/8DB8jAw8zAw8zY39EJC9UpL9UtL+Xd4/Jqc/MDB/7i6/7/BeREooAAAAA10Uk5TAAgRG2B5rq/L2eTw8xCqegsAAACXSURBVBjTdZHREsQQDEWjZVVRlNb//+kmxrY63ZyHDGfMRQLQmKQ2zhktJ7gRytaOVeJn56UOLHO3a32wNi/a2TOnEFI+23nKUbQq0TdioZ3CN9BtZfOdjbydQFJC9BeRciRorNkPZBQaDNZ91AmFAYc1jDqgcJymkPQO+Xvlh3sg8x3m81er9mermMZyY+CG1kd8HPeIv+aGGkS9vRLLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/e5_dot_red@2x.png
// module id = s8nn
// module chunks = 0